<template>
  <div class="vx-col w-full">
    <div class="mb-6">
      <HandleFieldSidebar
        :field="selectedField"
        @update:field="updateField"
        @delete:field="deleteField"
        :active="isFieldHandlerSidebarOpen"
        @update:active="isFieldHandlerSidebarOpen = $event"
      />
    </div>

    <vx-card
      class="mb-5"
      title="Form fields"
      style="transition: 0.5s ease-out"
      @refresh="closeCardAnimationDemo"
    >
      <!-- start -->
      <div class="px-3 mt-4">
        <!-- max-w-md -->
        <draggable
          tag="ul"
          group="all-questions"
          class="draggable-list"
          ghost-class="moving-card"
          filter=".action-button"
          :list="bookingForm.fields"
          :animation="200"
        >
          <FieldTemplateCard
            v-for="(field, idx) in bookingForm.fields"
            :field="field"
            :key="idx"
            @on-edit="onEdit"
          />
        </draggable>

        <!-- Add new start -->
        <vs-dropdown
          class="cursor-pointer flex"
          :vs-trigger-click="true"
          vs-custom-content
        >
          <div class="cursor-pointer">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">New field</span>
          </div>

          <vs-dropdown-menu style="z-index: 200001">
            <vs-dropdown-item
              @click.stop="addField(field)"
              class="px-0 py-2"
              v-for="(field, index) in availableFields"
              :key="index"
            >
              <feather-icon
                :icon="field.icon"
                class="
                  p-2
                  inline-flex
                  rounded-lg
                  bg-white
                  border border-solid border-grey
                  shadow
                "
                svgClasses="h-5 w-5"
              />
              <span class="ml-3">{{ field.name }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- Add new end -->
      </div>
      <!-- end -->
    </vx-card>

    <!-- Save & Remove Button -->
    <vs-row
      vs-justify="space-between"
      class="flex flex-wrap items-center"
      style="margin-top: 32px"
    >
      <vs-button
        @click="$emit('save')"
        v-if="hasPermission('vp.crm.bookingforms.edit')"
        >Save</vs-button
      >
      <!-- <vs-button color="danger" @click="$emit('publish')">Publish</vs-button> -->
    </vs-row>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import FieldTemplateCard from "./FieldTemplateCard.vue";
import HandleFieldSidebar from "./HandleFieldSidebar.vue";
import { mapGetters } from "vuex";
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap/dist/css/bootstrap.css'

export default {
  components: {
    Draggable,
    FieldTemplateCard,
    HandleFieldSidebar,
  },
  data() {
    return {
      selectedField: null,
      isFieldHandlerSidebarOpen: false,
    };
  },
  props: {
    bookingForm: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      availableFields: "bookingForms/availableFields",
    }),
  },
  methods: {
    async addField(field) {
      // TODO Check that field is not already added with corresponding technical type

      console.log("addField", field.type);
      const newField = await this.$store.dispatch(
        "bookingForms/createField",
        field.type
      );
      newField.technicalType = field.technicalType; // Set the technical type
      console.log("New field result after", newField, this.bookingForm.fields);

      this.bookingForm.fields.push(newField);
      this.handleFieldClick(newField);
    },
    handleFieldClick(field) {
      this.selectedField = { ...field };
      console.log("Open field sidebar", this.selectedField.label);
      this.isFieldHandlerSidebarOpen = true;
    },
    updateField() {
      this.bookingForm.fields = this.bookingForm.fields.map((field) => {
        if (field.id === this.selectedField.id) {
          console.log("Update field", field.label, this.selectedField.label);
          return { ...this.selectedField };
        }
        return field;
      });
      console.log("Updated field result", this.bookingForm.fields);

      this.selectedField = null;
    },
    deleteField() {
      this.bookingForm.fields = this.bookingForm.fields.filter(
        (field) => field.id !== this.selectedField.id
      );
      this.selectedField = null;
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
    },
    onEdit(field) {
      this.handleFieldClick(field);
    },
  },
  async mounted() {},
};
</script>



<style>
#sidebar-right {
  background-color: #fff;
}

.header-dark {
  background-color: #f6f6f6;
}

.draggable-list {
  min-height: 100px;
}
/* Unfortunately @apply cannot be setup in codesandbox, 
but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px dashed #4299e1;
}

.empty-draggable-area {
  background: #f7fafc;
  border: 1px dashed #4299e186;
  border-radius: 8px;
  height: 64px !important;
  max-height: 64px !important;
  min-height: 64px !important;
  margin-bottom: 15px;
}
</style>
